export default {"src":"/_next/static/image/public/images/ic_rx_doc.bcaf162768697b5fccefa602e67a6d23.svg","height":57,"width":57};